module.exports = __WEBPACK_EXTERNAL_MODULE_7__;


//////////////////
// WEBPACK FOOTER
// external "@angular/animations"
// module id = 7
// module chunks = 0